const { verticalSiteConfigs } = require('./verticalSiteConfigs');

const brands = [
  'news',
  'today',
  'msnbc',
];

const newsVerticals = [
  'mach',
  'better',
  'think',
  'globalcitizen',
  'know-your-value',
  'leftfield',
];

const telemundoVerticals = [
  'noticias',
  'shows',
  'entretenimiento',
];

const verticalNameMap = {
  better: 'BETTER',
  globalcitizen: 'Global Citizen',
  knowyourvalue: 'Know Your Value',
  leftfield: 'Left Field',
  mach: 'MACH',
  msnbc: 'MSNBC',
  news: 'NBC News',
  think: 'THINK',
  today: 'TODAY',
  noticias: 'Noticias Telemundo',
};

const verticalSlugMap = {
  better: 'better',
  globalcitizen: 'global-citizen',
  knowyourvalue: 'know-your-value',
  leftfield: 'left-field',
  mach: 'mach',
  msnbc: 'msnbc',
  news: 'news',
  think: 'think',
  today: 'today',
  noticias: 'noticias',
};

const verticals = [
  ...brands,
  ...newsVerticals,
  ...telemundoVerticals,
];

const publicoHeadlineBrands = ['knowyourvalue', 'think', 'today'];

const isIn = (v, verticalList) => verticalList.indexOf(v) !== -1;

const isNotIn = (v, verticalList) => verticalList.indexOf(v) === -1;

const isMain = (v) => brands.indexOf(v) !== -1;

const isSub = (v) => newsVerticals.indexOf(v) !== -1;

const getDisplayNameForVertical = (vertical) => (verticalNameMap[vertical] || '');

const getSlugForVertical = (vertical) => (verticalSlugMap[vertical] || vertical);

const hasPublisherRestriction = (publisher, vertical) => {
  if (publisher && (
    // Only show MSNBC content on MSNBC
    (publisher !== 'msnbc' && vertical === 'msnbc')
    // Do not show MSNBC content on other domains
    || (publisher === 'msnbc' && vertical !== 'msnbc')
  )) {
    return true;
  }
  return false;
};

const isTelemundoVertical = (vertical) => [...telemundoVerticals, 'telemundo'].includes(vertical);


const getSiteConfigs = (vertical) => verticalSiteConfigs[vertical]
  || verticalSiteConfigs.news;

module.exports = {
  brands,
  getDisplayNameForVertical,
  getSiteConfigs,
  getSlugForVertical,
  hasPublisherRestriction,
  isIn,
  isMain,
  isNotIn,
  isSub,
  isTelemundoVertical,
  newsVerticals,
  publicoHeadlineBrands,
  telemundoVerticals,
  verticals,
  verticalNameMap,
  verticalSlugMap,
};
